export default __webpack_public_path__ + "static/media/tech_camp_at_locationBGSmall.1efa439d.jpg";